import { type ClassValue, clsx } from "clsx";

/**
 * Utility function for merging class names
 * Similar to ShadCN's cn utility function
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}